import React from "react";
import { Form, Input } from "antd";
import AppLogo from "../../components/Logo/AppLogo";
import DefaultButton from "../../components/buttons/DefaultButton";
import { Link, useNavigate } from "react-router-dom";
import Authshell from "../../layouts/AuthShell";
import { useLoginMutation } from "./provider";

const Login = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { isLoading, mutate } = useLoginMutation();

  function loginUser(values) {
    mutate(values);
  }

  return (
    <Authshell>
      <div className="h-full flex flex-col justify-center items-center">
        <AppLogo className="w-48 mb-16" />
        <h1 className="app-text text-xl font-bold mb-5">Log In</h1>
        <Form
          form={form}
          className="auth-form app-form rounded-lg flex flex-col justify-center items-center w-full md:w-128 py-12 md:px-10 px-5"
          layout="vertical"
          requiredMark={false}
          onFinish={loginUser}
        >
          <Form.Item
            className="w-full"
            name="email"
            rules={[
              { required: true, message: "Please input your E-mail!" },
              { type: "email", message: "The input is not valid E-mail!" },
            ]}
          >
            <Input placeholder="Email" className="app-input" />
          </Form.Item>

          <Form.Item
            className="w-full"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Password" className="app-input" />
          </Form.Item>
          <div className="mt-4">
            <DefaultButton
              htmlType="submit"
              className="h-10"
              loading={isLoading}
            >
              Login
            </DefaultButton>
          </div>
        </Form>
        <Link to="/forgot-password" className="app-text text-[16px] my-5">
          Forgot your password?
        </Link>
        <div className="flex flex-col md:flex-row flex-wrap items-center justify-center mt-3 md:space-x-5 space-x-0 md:space-y-0 space-y-3">
          <p className="app-text text-sm md:text-lg text-center font-bold">
            Don't have an account?
          </p>
          <DefaultButton
            htmlType="submit"
            className="py-5"
            onClick={() => navigate("/register/location")}
          >
            Get Started
          </DefaultButton>
        </div>
      </div>
    </Authshell>
  );
};

export default Login;
